import { render, staticRenderFns } from "./InputVials.vue?vue&type=template&id=281daf64&"
import script from "./InputVials.vue?vue&type=script&lang=js&"
export * from "./InputVials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports